import { LocalizationKeys } from './constant';

const de: LocalizationKeys = {
	skip: 'Skip'
};

export default de;
